import * as React from "react";
import {
    Grid,
    Button,
    Typography,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent
} from "components/controls/widget";
import { FormControl, buildFormControlProps } from "components/controls/FormControl";
import { useMemberValidation, isMemberValidationState, MemberValidationState } from "./store";


interface Props {
    memberIdt: number;
}

const View = ({ memberIdt }: Props) => {

    const [state, actions] = useMemberValidation();


    const fieldDef = buildFormControlProps("code", { 'code': { label: 'Ověřovací kód' } }, state, actions);


    return <Dialog open={true} scroll="paper" >
        <DialogTitle>{'Ověření telefonu'}</DialogTitle>
        <DialogContent>
            <Grid container direction="column" spacing={8}>
                <FormControl {...fieldDef} autoFocus />
                <Grid item>
                    <Typography variant="subtitle2">{'Vložte ověřovací kód ze SMS zprávy.'}</Typography>
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button color="primary" variant="contained" onClick={() => actions.validatePhone(memberIdt)}>{'Ověřit'}</Button>
            <Button variant="contained" onClick={() => actions.showPhoneVerificationCodeDialog(false)}>{'Zpět'}</Button>
        </DialogActions>
    </Dialog>
}

export {
    View as PhoneVerificationCodeDialog,
}